import React from 'react';
import GroupedStatusList from './GroupedStatusList';
import NodeRow from './NodeRow';

export default function NodeDiffList({ nodes, viewMode, expandedNodeIds, jumpTargetIds, onToggleNode, registerNodeRef }) {
  return (
    <GroupedStatusList
      title="Canvas nodes"
      items={nodes}
      isForcedOpen={(n) => jumpTargetIds.has(n.id)}
      renderItem={(n) => (
        <NodeRow
          key={n.id}
          ref={(el) => registerNodeRef(n.id, el)}
          id={n.id}
          oldNode={n.oldNode}
          newNode={n.newNode}
          status={n.status}
          viewMode={viewMode}
          expanded={expandedNodeIds.has(n.id)}
          onToggle={() => onToggleNode(n.id)}
        />
      )}
    />
  );
}
